/* eslint-disable react/no-unused-state,react/no-unescaped-entities */
import React, { Component, Fragment } from 'react';
import { Card, CardBody, Col, UncontrolledTooltip } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import CopyToClipboard from 'react-copy-to-clipboard';
import isEmpty from 'lodash/isEmpty';
import numeral from 'numeral';

import store from '../../App/store'
import { loadCampaignsAction } from '../../../redux/actions/campaignsActions'

import OffersFilters from './OffersFilters';
import CustomizableTable from '../../../common/table/customizableTable';
import Pagination from '../../../shared/components/pagination/Pagination';
import {
  getSavedOrderOfColumns,
  renderRevenueTypeTitle,
  renderConvTypeTitle,
  renderConvTypeRateTitle,
  getCurrencySign,
} from '../../../utils';
import { sum } from '../../../utils/Helpers';
import noty from '../../../utils/noty'
import shortid from "shortid"
import {
  INITIAL_PAGE_NUMBER,
  INITIAL_ROWS_COUNT,
  INITIAL_ROWS_COUNT_OFFERS,
  STATUS_CAMPAIGN_DELETED,
  TOTAL_TEXT,
  ALLOWED_TRAFFIC,
  ALL_COUNTRIES_ALLOWED,
  COPY_NOTIFICATION,
  NA_VALUE,
} from '../../../constants';
import { LoadableContainer } from "../../../widgets";

import LinkIcon from 'mdi-react/LinkIcon'

const copyTrackbackLink = (url) => noty({ text: COPY_NOTIFICATION })

const LinkFormatter = ({ value, original }) => {
  return TOTAL_TEXT === value ? value : <Link to={`/offers/${original.id}`} className='custom-link-element'>{value}</Link>
}

const ReportLinkFormatter = ({ value, original }) => {
  return original.id ? <Link to={`/offers/report/${original.id}`} className='custom-link-element'>Campaign Report</Link> : ''
}

const PreviewLinkFormatter = ({ value, original }) => {
  return original.id ? <a target={'blank'} href={value} className='custom-link-element'>Preview</a> : ''
}

const TrackingLinkFormatter = ({ value, original, viewIndex }) => {
  let data = ''
  if (original.id) {
    const customId = `id_${shortid.generate()}`;
    data = (<div className="offer-urls-container">
      <a target={'blank'} href={value}>Campaign URL</a>
      <CopyToClipboard id={customId} text={value} onCopy={copyTrackbackLink}>
        <div className="ml-10">
          <a href="javascript:;">
            <LinkIcon
              className="customize-icon"
            />
          </a>
        </div>
      </CopyToClipboard>
      <UncontrolledTooltip placement={viewIndex % 2 === 0 ? 'right' : 'top'} target={customId}>
        {value}
      </UncontrolledTooltip>
    </div>)
  }
  return data
}

const TrackingLinkFormatterMin = ({ value, original }) => {
  let data = ''
  if (original.id) {
    const customId = `id_${shortid.generate()}`;
    data = (<div className="offer-urls-container">
      <a target={'blank'} href={value}>Campaign URL</a>
      <CopyToClipboard id={customId} text={value} onCopy={copyTrackbackLink}>
        <div className="ml-10">
          <a href="javascript:;">
            <LinkIcon
              className="customize-icon"
            />
          </a>
        </div>
      </CopyToClipboard>
      <UncontrolledTooltip placement="right" target={customId}>
        {value}
      </UncontrolledTooltip>
    </div>)
  }
  return data
}

class OffersTable extends Component {
  constructor (props) {
    super(props);
    this.state = {
      heads: [],
      defaultHeads: [
        {
          title: 'Type',
          accessor: 'cost_model',
          minWidth: 120,
          width: 120,
          Header: () => <span>Type</span>,
          Cell: (row) => {
            const { publisher_details } = row.original;
            const { campaign_type } = publisher_details || {};
            return <span>{campaign_type || NA_VALUE}</span>;
          },
        },
        {
          title: 'Rate',
          accessor: 'rate',
          minWidth: 120,
          width: 120,
          Header: () => <span>Rate</span>,
          Cell: (row) => {
            const { publisher_details } = row.original;
            const { campaign_rate } = publisher_details || {};
            const status = campaign_rate.status;
            let value = campaign_rate.value;
            if (status === 1) {
              value = '-';
            }
            return <span>{value}</span>;
          },
        },
        {
          title: 'Category',
          accessor: 'category',
          minWidth: 120,
          width: 120,
          Header: () => <span>Category</span>,
        },
        {
          title: 'Countries',
          accessor: 'countries',
          minWidth: 120,
          width: 120,
          Header: () => <span>Countries</span>,
        },
        {
          title: 'Source',
          accessor: 'source_title',
          minWidth: 120,
          width: 120,
          Header: () => <span>Source</span>,
        },
        {
          title: 'Report',
          accessor: 'report',
          minWidth: 140,
          width: 140,
          Header: () => <span>Report</span>,
          Cell: ReportLinkFormatter,
        },
        {
          title: 'Preview',
          accessor: 'preview_url',
          minWidth: 120,
          width: 120,
          Header: () => <span>Preview</span>,
          Cell: PreviewLinkFormatter,
        },
        {
          title: 'Tracking url',
          accessor: 'trackback_url',
          minWidth: 140,
          width: 140,
          Header: () => <span>Tracking url</span>,
          Cell: TrackingLinkFormatter,
        },
      ],
      statHeads: [],
      defaultHeadColumn: {
        title: 'Title',
        Header: () => <span>Title</span>,
        accessor: 'title',
        minWidth: 500,
        width: 500,
        Cell: LinkFormatter,
        Footer: <span>Total:</span>,
      },
      rows: [],
      rowsToShow: [],
      pageOfItems: INITIAL_PAGE_NUMBER,
      itemsToShow: INITIAL_ROWS_COUNT_OFFERS,
      columnsRenderer: this._renderOffersColumns,
    };
  }

  static getDerivedStateFromProps (props, state) {
    const usersSettings = props.users && props.users.settings || {}
    const tables = usersSettings && usersSettings.settings ? usersSettings.settings : []
    const sortedHeads = getSavedOrderOfColumns(state.columnsRenderer(props.offers.items, usersSettings), tables, 'id')
    state.defaultHeads.map(el => {
      if (el.accessor === 'trackback_url') {
        el.Cell = props.offers.items.length <= 4 ? TrackingLinkFormatterMin : TrackingLinkFormatter
      }
    })
    return {
      ...state,
      rows: props.offers.items,
      heads: [{...state.defaultHeadColumn}, ...state.defaultHeads, ...sortedHeads],
    }
  }

  componentDidMount () {
    store.dispatch(loadCampaignsAction).then((data) => {
      const { pageOfItems, itemsToShow } = this.state;
      const preparedItems = data || []
      const items = preparedItems.filter((el,i) => el && el.status !== STATUS_CAMPAIGN_DELETED)
      const currentPageRows = this.filterRows(items, pageOfItems, itemsToShow);
      this.setState({ rows: data, rowsToShow: currentPageRows });
    })
  }

  handleApplyFilters = () => {
    store.dispatch(loadCampaignsAction).then((data) => {
      const { pageOfItems, itemsToShow } = this.state;
      const preparedItems = data || []
      const items = preparedItems.filter((el,i) => el && el.status !== STATUS_CAMPAIGN_DELETED)
      const currentPageRows = this.filterRows(items, pageOfItems, itemsToShow);
      this.setState({ rows: data, rowsToShow: currentPageRows });
    })
  }

  _renderLikeTags = (data) => {
    return data.map((el, i) => <span className={`${i !== 0 ? 'pl-10 pr-10' : 'pr-10'}`}>{el}</span>)
  }

  _renderPublisherCategories = (pubDetails) => {
    let categories = ''
    if (pubDetails && pubDetails.categories) {
      categories = pubDetails.categories.join(', ')
    }

    return categories
  }

  prepareCompanyData = (data) => {
    let items = data || [];
    let itemsToRender = [];
    itemsToRender = items.map((el) => {
      const pubDetails = el.publisher_details
      let allowedTraffic = ALLOWED_TRAFFIC
      let publisherCountries = pubDetails && pubDetails.countries ? pubDetails.countries.filter((el) => el !== '').join(', ') : ALL_COUNTRIES_ALLOWED
      if (pubDetails && pubDetails.countries && pubDetails.countries.length === 1) {
        publisherCountries = pubDetails.countries[0] !== '' ? pubDetails.countries.join(', ') : ALL_COUNTRIES_ALLOWED
      } else if (pubDetails && pubDetails.countries && pubDetails.countries.length === 0) {
        publisherCountries = ALL_COUNTRIES_ALLOWED
      }
      if (!pubDetails && isEmpty(pubDetails)) {
        return el
      }
      if (el.cost_model === '') {
        el.cost_model = NA_VALUE
      } else if (el.cost_model === 'RevShare') {
        el.rate = el.rev_share + '%'
      } else {
        el.rate = el.cpc
      }
      if (pubDetails && pubDetails.sources && pubDetails.sources.length !== 0) {
        allowedTraffic = pubDetails.sources.join(', ')
      }
      el.source_title = allowedTraffic;
      el.category = this._renderPublisherCategories(pubDetails);
      el.countries = publisherCountries;
      el.cap = NA_VALUE;
      el.availability = 'Public';
      el.preview_url = pubDetails.preview_url || '#';
      return el
    });
    return itemsToRender;
  };


  _renderOffersColumns = (offers, user) => {
    const currencySign = getCurrencySign(user)
    return [
      {
        id: 'impressions',
        title: 'Impressions',
        className: '',
        accessor: 'stat.impressions',
        minWidth: 120,
        width: 120,
        Header: () => <span>Impressions</span>,
        Cell: row => (row.value || 0),
        Footer: footer => sum((offers || []).map(row => row.stat.impressions)),
      },
      {
        id: 'clicks',
        title: 'Clicks',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.clicks',
        Header: () => <span>Clicks</span>,
        Cell: row => (row.value || 0),
        Footer: footer => sum((offers || []).map(row => row.stat.clicks)),
      },
      {
        id: 'unique_clicks',
        title: 'Unique clicks',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.unique_clicks',
        Header: () => <span>Unique clicks</span>,
        Cell: row => (row.value || 0),
        Footer: footer => sum((offers || []).map(row => row.stat.unique_clicks)),
      },
      {
        id: 'ctr',
        title: 'CTR',
        className: 'bolder',
        minWidth: 120,
        width: 120,
        accessor: 'stat.ctr',
        Cell: row => numeral(row.value).format('0.00%'),
        Header: () => <span>CTR</span>,
        Footer: footer => {
          const impressions = sum((offers || []).map(row => row.stat.impressions))
          const clicks = sum((offers || []).map(row => row.stat.clicks))
          return numeral(impressions !== 0 ? clicks / impressions : 0).format('0.00%')
        },
      },
      {
        id: 'lp_views',
        title: 'LP Views',
        className: 'bolder',
        minWidth: 120,
        width: 120,
        accessor: 'stat.lp_views',
        description: 'Landing page views',
        Cell: row => (row.value || 0),
        Header: () => <span>LP Views</span>,
        Footer: footer => sum((offers || []).map(row => row.stat.lp_views)),
      },
      {
        id: 'lp_clicks',
        title: 'LP clicks',
        className: 'bolder',
        minWidth: 120,
        width: 120,
        accessor: 'stat.lp_clicks',
        description: 'Clicks from Lander to offer',
        Cell: row => (row.value || 0),
        Header: () => <span>LP Clicks</span>,
        Footer: footer => sum((offers || []).map(row => row.stat.lp_clicks)),
      },
      {
        id: 'lp_ctr',
        title: 'LP CTR',
        className: 'bolder',
        minWidth: 120,
        width: 120,
        accessor: 'stat.lp_ctr',
        description: 'LP Clicks to LP views ratio',
        Cell: row => numeral(row.value).format('0.00%'),
        Header: () => <span>LP CTR</span>,
        Footer: footer => {
          const lp_clicks = sum((offers || []).map(row => row.stat.lp_clicks))
          const lp_views = sum((offers || []).map(row => row.stat.lp_views))
          return numeral(lp_views !== 0 ? lp_clicks / lp_views : 0).format('0.00%')
        },
      },
      {
        id: 'lp_click_ctr',
        title: 'LP Click CTR',
        className: 'bolder',
        minWidth: 120,
        width: 120,
        accessor: 'stat.lp_click_ctr',
        description: 'Clicks to LP clicks Ratio',
        Cell: row => numeral((row.original.stat.lp_clicks && row.original.stat.clicks !== 0) ? row.original.stat.lp_clicks/row.original.stat.clicks : 0).format('0.00%'),
        Header: () => <span>LP Click CTR</span>,
        Footer: footer => {
          const lp_clicks = sum((offers || []).map(row => row.stat.lp_clicks))
          const clicks    = sum((offers || []).map(row => row.stat.clicks))
          return numeral(clicks !== 0 ? lp_clicks / clicks : 0).format('0.00%')
        },
      },
      {
        id: 'conversions',
        title: renderConvTypeTitle('conv_default_type','conv_', user),
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.conversions',
        Cell: row => (row.value || 0),
        Header: () => <span>{renderConvTypeTitle('conv_default_type','conv_', user)}</span>,
        Footer: footer => sum((offers || []).map(row => row.stat.conversions)),
      },
      {
        id: 'total_conversions_cr',
        className: '',
        title: 'Total Actions CR',
        minWidth: 120,
        width: 120,
        accessor: 'stat.total_conversions_cr',
        Cell: row => numeral(row.original.stat.total_conversions && row.original.stat.clicks !== 0 ? row.original.stat.total_conversions / row.original.stat.clicks : 0).format('0.00%'),
        Header: () => <span>Total Actions CR</span>,
        Footer: t => {
          const conversions = sum((offers || []).map(row => row.stat.total_conversions))
          const clicks = sum((offers || []).map(row => row.stat.clicks))
          return numeral(clicks !== 0 ? conversions / clicks : 0).format('0.00%')
        },
      },
      {
        id: 'total_conversions',
        title: 'Total Actions',
        className: '',
        minWidth: 150,
        width: 150,
        accessor: 'stat.total_conversions',
        Cell: row => (row.value || 0),
        Header: () => <span>Total Actions</span>,
        Footer: footer => sum((offers || []).map(row => row.stat.total_conversions)),
      },
      {
        id: 'cr',
        title: 'CR',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.cr',
        description: 'Conversion rate (clicks to conversions)',
        Cell: row => numeral(row.value).format('0.00%'),
        Header: () => <span>CR</span>,
        Footer: footer => {
          const conversions = sum((offers || []).map(row => row.stat.conversions))
          const clicks = sum((offers || []).map(row => row.stat.clicks))
          return numeral(clicks !== 0 ? conversions / clicks : 0).format('0.00%')
        },
      },
      {
        id: 'approved',
        title: 'Approved',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.approved',
        Header: () => <span>Approved</span>,
        Cell: row => (row.value || 0),
        Footer: footer => sum((offers || []).map(row => row.stat.approved)),
      },
      {
        id: 'approved_rate',
        title: 'Approved rate',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.approved_rate',
        Cell: row => numeral(row.original.stat.approved ? row.original.stat.approved/row.original.stat.clicks : 0).format('0.00%'),
        Header: () => <span>Approved rate</span>,
        Footer: footer => {
          const approved = sum((offers || []).map(row => row.stat.approved))
          const clicks = sum((offers || []).map(row => row.stat.clicks))
          return numeral(clicks !== 0 ? approved / clicks : 0).format('0.00%')
        },
      },
      {
        id: 'pending',
        title: 'Pending',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.pending',
        Header: () => <span>Pending</span>,
        Cell: row => (row.value || 0),
        Footer: footer => sum((offers || []).map(row => row.stat.pending)),
      },
      {
        id: 'pending_rate',
        title: 'Pending rate',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.pending_rate',
        Cell: row => numeral(row.original.stat.pending ? row.original.stat.pending/row.original.stat.clicks : 0).format('0.00%'),
        Header: () => <span>Pending rate</span>,
        Footer: footer => {
          const pending = sum((offers || []).map(row => row.stat.pending))
          const clicks = sum((offers || []).map(row => row.stat.clicks))
          return numeral(clicks !== 0 ? pending / clicks : 0).format('0.00%')
        },
      },
      {
        id: 'declined',
        title: 'Declined',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.declined',
        Cell: row => (row.value || 0),
        Header: () => <span>Declined</span>,
        Footer: footer => sum((offers || []).map(row => row.stat.declined)),
      },
      {
        id: 'declined_rate',
        title: 'Declined rate',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.declined_rate',
        Cell: row => numeral(row.original.stat.declined ? row.original.stat.declined/row.original.stat.clicks : 0).format('0.00%'),
        Header: () => <span>Declined rate</span>,
        Footer: footer => {
          const declined = sum((offers || []).map(row => row.stat.declined))
          const clicks = sum((offers || []).map(row => row.stat.clicks))
          return numeral(clicks !== 0 ? declined / clicks : 0).format('0.00%')
        },
      },
      {
        id: 'other',
        title: 'Other',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.other',
        Header: () => <span>Other</span>,
        Cell: row => (row.value || 0),
        Footer: footer => sum((offers || []).map(row => row.stat.other)),
      },
      {
        id: 'other_rate',
        title: 'Other rate',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.other_rate',
        Cell: row => numeral(row.original.stat.other ? row.original.stat.other/row.original.stat.clicks : 0).format('0.00%'),
        Header: () => <span>Other rate</span>,
        Footer: footer => {
          const other = sum((offers || []).map(row => row.stat.other));
          const clicks = sum((offers || []).map(row => row.stat.clicks));
          return numeral(clicks !== 0 ? other / clicks : 0).format('0.00%')
        },
      },
      {
        id: 'transactions',
        title: 'Transactions',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.transactions',
        Cell: row => (row.value || 0),
        Header: () => <span>Transactions</span>,
        Footer: footer => sum((offers || []).map(row => row.stat.transactions)),
      },
      {
        id: 'revenue',
        title: renderRevenueTypeTitle('revenue_default_type','revenue_', user),
        className: 'bolder',
        minWidth: 180,
        width: 180,
        accessor: 'stat.revenue',
        Cell: row => `${currencySign}${numeral(row.value).format('0.00[00]')}`,
        Header: () => <span>{renderRevenueTypeTitle('revenue_default_type','revenue_', user)}</span>,
        Footer: footer => `${currencySign}${numeral(sum((offers || []).map(row => row.stat.revenue))).format('0.00[00]')}`,
      },
      {
        id: 'total_revenue',
        title: 'Total Revenue',
        className: 'bolder',
        minWidth: 180,
        width: 180,
        accessor: 'stat.total_revenue',
        Cell: row => `${currencySign}${numeral(row.value).format('0.00[00]')}`,
        Header: () => <span>Total Revenue</span>,
        Footer: footer => `${currencySign}${numeral(sum((offers || []).map(row => row.stat.total_revenue))).format('0.00[00]')}`,
      },
      {
        id: 'cost',
        title: 'Cost',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.cost',
        Cell: row => `${currencySign}${numeral(row.value).format('0.00[00]')}`,
        Header: () => <span>Cost</span>,
        Footer: footer => `${currencySign}${numeral(sum((offers || []).map(row => row.stat.cost))).format('0.00[00]')}`,
      },
      {
        id: 'pub_revenue',
        title: 'Commission',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.pub_revenue',
        Cell: row => `${currencySign}${numeral(row.value).format('0.00[00]')}`,
        Header: () => <span>Commission</span>,
        Footer: footer => `${currencySign}${numeral(sum((offers || []).map(row => row.stat.pub_revenue))).format('0.00[00]')}`,
      },
      {
        id: 'profit',
        title: 'Profit',
        className: 'bolder',
        minWidth: 120,
        width: 120,
        accessor: 'stat.profit',
        Cell: row => `${currencySign}${numeral(row.value).format('0.00[00]')}`,
        Header: () => <span>Profit</span>,
        Footer: footer => `${currencySign}${numeral(sum((offers || []).map(row => row.stat.profit))).format('0.00[00]')}`,
      },
      {
        id: 'roi',
        title: 'ROI',
        className: 'bolder',
        minWidth: 120,
        width: 120,
        accessor: 'stat.roi',
        description: 'Return on Investment',
        Cell: row => numeral(row.value).format('0.00%'),
        Header: () => <span>ROI</span>,
        Footer: footer => {
          const profit = sum((offers || []).map(row => row.stat.profit))
          const cost   = sum((offers || []).map(row => row.stat.cost))
          return numeral(cost !== 0 ? profit / cost : 0).format('0.00%')
        },
      },
      {
        id: 'cpa',
        title: 'CPA',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.cpa',
        description: 'Cost per Action',
        Cell: row => `${currencySign}${numeral(row.value).format('0.00[00]')}`,
        Header: () => <span>CPA</span>,
        Footer: footer => {
          const conversions = sum((offers || []).map(row => row.stat.conversions))
          const cost = sum((offers || []).map(row => row.stat.cost))
          return `${currencySign}${numeral(conversions !== 0 ? cost / conversions : 0).format('0.00[00]')}`
        },
      },
      {
        id: 'cpc',
        title: 'CPC',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.cpc',
        description: 'Cost per Click',
        Cell: row => `${currencySign}${numeral(row.value).format('0.00[00]')}`,
        Header: () => <span>CPC</span>,
        Footer: footer => {
          const clicks = sum((offers || []).map(row => row.stat.clicks))
          const cost   = sum((offers || []).map(row => row.stat.cost))
          return `${currencySign}${numeral(clicks !== 0 ? cost / clicks : 0).format('0.00[00]')}`
        },
      },
      {
        id: 'cpt',
        title: 'CPT',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.cpt',
        description: 'Cost per Transaction',
        Cell: row => `${currencySign}${numeral(row.value).format('0.00[00]')}`,
        Header: () => <span>CPT</span>,
        Footer: footer => {
          const transactions = sum((offers || []).map(row => row.stat.transactions))
          const cost = sum((offers || []).map(row => row.stat.cost))
          return `${currencySign}${numeral(transactions !== 0 ? cost / transactions : 0).format('0.00[00]')}`
        },
      },
      {
        id: 'epc',
        title: 'EPC',
        className: '',
        minWidth: 120,
        width: 120,
        accessor: 'stat.epc',
        description: 'Earning per click',
        Cell: row => `${currencySign}${numeral(row.value).format('0.00[00]')}`,
        Header: () => <span>EPC</span>,
        Footer: footer => {
          const revenue = sum((offers || []).map(row => row.stat.total_revenue))
          const clicks   = sum((offers || []).map(row => row.stat.clicks))
          return `${currencySign}${numeral(clicks !== 0 ? revenue / clicks : 0).format('0.00[00]')}`
        },
      },
      ...(Array.from({ length: 40 }, (el, i) => i + 1).map((count) => (
        {
          id: `convtype${count}`,
          title: renderConvTypeTitle(`convtype${count}`,'conv', user),
          accessor: `stat.convtype${count}`,
          minWidth: 120,
          width: 120,
          Header: () =>
            <span>
              {renderConvTypeTitle(`convtype${count}`,'conv', user)}
            </span>,
          Cell: row => (row.value || 0),
          Footer: t => sum((offers || []).map(row => row.stat[`convtype${count}`])),
        }
      ))),
      ...(Array.from({ length: 40 }, (el, i) => i + 1).map((count) => (
        {
          id: `convratetype${count}`,
          title: renderConvTypeRateTitle(`convtype${count}`,'conv', user),
          className: '',
          accessor: `stat.convratetype${count}`,
          minWidth: 120,
          width: 120,
          Cell: row => numeral(row.original.stat[`convtype${count}`] && row.original.stat.clicks !== 0 ? row.original.stat[`convtype${count}`] / row.original.stat.clicks : 0).format('0.00%'),
          Header: () =>
            <span>
              {renderConvTypeRateTitle(`convtype${count}`,'conv', user)}
            </span>,
          Footer: t => {
            const conversions = sum((offers || []).map(row => row.stat[`convtype${count}`]))
            const clicks = sum((offers || []).map(row => row.stat.clicks))
            return numeral(clicks !== 0 ? conversions / clicks : 0).format('0.00%')
          },
        }
      ))),
      ...(Array.from({ length: 40 }, (el, i) => i + 1).map((count) => (
        {
          id: `revenuetype${count}`,
          title: renderRevenueTypeTitle(`revenuetype${count}`,'revenue', user),
          className: '',
          accessor: `stat.revenuetype${count}`,
          minWidth: 180,
          width: 180,
          Header: () =>
            <span>
              {renderRevenueTypeTitle(`revenuetype${count}`,'revenue', user)}
            </span>,
          Cell: row => `${currencySign}${numeral(row.value || 0).format('0.00[00]')}`,
          Footer: t => `${currencySign}${numeral(sum((offers || []).map(row => row.stat[`revenuetype${count}`]))).format('0.00[00]')}`,
        }
      ))),
    ]
  }

  onChangePage = (pageOfItems) => {
    const { itemsToShow } = this.state;
    const { offers } = this.props;
    if (pageOfItems) {
      const rowsToShow = this.filterRows(offers.items, pageOfItems, itemsToShow);
      this.setState({ rowsToShow, pageOfItems, rows: offers.items });
    }
  };

  filterRows = (originalRows, pageNumber, rowsOnPage) => {
    const rowsFrom = rowsOnPage * (pageNumber - 1);
    const rowsTo = rowsFrom + rowsOnPage;
    const data = originalRows.slice(rowsFrom, rowsTo)
    return data
  };

  renderRowColor = (row) => {
    let rowColor = '';
    const index  = row.index|| row.viewIndex
    if (index % 2 === 0) {
      rowColor = 'custom-odd'
    } else {
      rowColor = 'custom-even'
    }
    return rowColor
  };

  render () {
    const { pageOfItems, itemsToShow, rowsToShow, rows, heads } = this.state;
    const { loading, loaded } = this.props;
    const itemsToRender = this.prepareCompanyData(rowsToShow);
    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <OffersFilters
              handleApplyFilters={this.handleApplyFilters}
            />
            <LoadableContainer
              loading={loading}
              loaded={loaded}
              style={{
                position: 'relative',
                width: '100%',
                maxHeight: '350px'
              }}
            >
              {itemsToRender &&
              <Fragment>
                <Pagination
                  className='offer-pagination-top'
                  itemsCount={rows.length}
                  itemsToShow={itemsToShow}
                  pageOfItems={pageOfItems}
                  onChangePage={this.onChangePage}
                />
                <CustomizableTable
                  className='custom-data-offer-table'
                  columns={heads}
                  data={rowsToShow}
                  style={{ maxHeight: "100%", borderLeft: 0, borderRight: 0, borderBottom: 0, width: '100%' }}
                  showPagination={false}
                  pageSize={rowsToShow.length}
                  loading={loading}
                  getTrProps={(state, row, column, instance) => ({
                    className: (row && row.original && this.renderRowColor(row)),
                  })}
                />
                <Pagination
                  itemsCount={rows.length}
                  itemsToShow={itemsToShow}
                  pageOfItems={pageOfItems}
                  onChangePage={this.onChangePage}
                />
              </Fragment>
              }
            </LoadableContainer>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  offers: state.campaigns,
  loading: state.campaigns.loading,
  loaded: state.campaigns.loaded,
  users: state.users
});

export default connect(
  mapStateToProps,
)(OffersTable)
